import { ErrorItemResponseDtoCode, ErrorResponseDto } from '@/apis/rest/generated/types'
import { ErrorType } from '@/plugins/rest-api-v4'

export const isErrorType = (error: any): error is ErrorType<ErrorResponseDto> => {
  const firstError = error?.response?.data?.errors[0]
  if (!firstError) {
    return false
  }
  if (!firstError?.code) {
    return false
  }
  return Object.values(ErrorItemResponseDtoCode).includes(firstError.code)
}
